import BaseToken from './BaseToken.js';

class ProviderToken extends BaseToken {
  constructor() {
    super('provider');
  }
}

export default new ProviderToken();
